import API from '../api';
import { REQUEST_SERVICE_HISTORY, RECEIVE_SERVICE_HISTORY } from '../constants';

export const getServiceHistory = (search: string = '', page = 0) => async (
  dispatch,
) => {
  dispatch({
    type: REQUEST_SERVICE_HISTORY,
  });
  const response = await API.request(
    `/service/history?search=${search}&offset=${page}`,
  );
  const {
    data: { lastPage, services },
  } = await response.json();
  dispatch({
    type: RECEIVE_SERVICE_HISTORY,
  });
  return { lastPage, services };
};
